import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const AdsFunnelPage: React.FC = () => {
  const funnel = analyticsSnapshot.crossChannelAnalysis.funnel;
  const latest = funnel.datasets.map((dataset) => ({
    label: dataset.label,
    ...findLatestValue(dataset.data)
  }));
  const latestLabel = latest[0].index >= 0 ? funnel.labels[latest[0].index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.crossChannelAnalysis.funnel.insights;

  const chartData = useMemo<ChartData<'line'>>(
    () => ({
      labels: Array.from(funnel.labels),
      datasets: funnel.datasets.map((dataset) => ({
        label: dataset.label,
        data: Array.from(dataset.data)
      }))
    }),
    [funnel.labels, funnel.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Reklam Dönüşüm Hunisi</h1>
          <p className="text-white/70 mt-2">
            Gösterimden satın almaya kadar tüm aşamalardaki performansı analiz ederek darboğazları bulun.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{latestLabel}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {latest.map((stage) => (
          <MetricSummary key={stage.label} title={stage.label} value={stage.value} description="Son ölçülen ay" />
        ))}
      </div>

      <ChartCard
        title="Aylık Huninin Aşamaları"
        description="Gösterimden satın almaya kadar tüm aşamalardaki dönüşümü izleyin."
        data={chartData}
        chartType="line"
        insights={insights}
      />

    </div>
  );
};

export default AdsFunnelPage;

